import React from 'react';
import { Grid, Header, Image } from 'semantic-ui-react';
import FileUploadButton from '../../fileUploadButton';

const EventImages = ({ obj, onChange }) => {
  return (
    <div>
      <Grid columns={2}>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Header as="h3">Header</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            {obj.header_desktop && <Image src={obj.header_desktop} />}
            <FileUploadButton
              id="header_desktop"
              label="Header (desktop)"
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            {obj.header_mobile && <Image src={obj.header_mobile} />}
            <FileUploadButton
              id="header_mobile"
              label="Header (mobile)"
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Header as="h3">Bloc contenu de l'événement</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            {obj.visual_desktop && <Image src={obj.visual_desktop} />}
            <FileUploadButton
              id="visual_desktop"
              label="Visuel Desktop"
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            {obj.visual_mobile && <Image src={obj.visual_mobile} />}
            <FileUploadButton
              id="visual_mobile"
              label="Visuel Mobile"
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Header as="h3">Bloc Push Facebook de l'événement</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            {obj.fb_cover && <Image src={obj.fb_cover} />}
            <FileUploadButton
              id="fb_cover"
              label="Image Facebook Push"
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default EventImages;



// WEBPACK FOOTER //
// ./src/components/form/event/images.js